export type TParticipantSelectionMode = 'employees' | 'departments' | 'positions'

export const PARTICIPANT_MODE_ITEMS: {
  title: string
  value: TParticipantSelectionMode
  icon: string
}[] = [
  { title: 'Сотрудники', value: 'employees', icon: 'ri-group-line' },
  { title: 'Отделения', value: 'departments', icon: 'ri-hospital-line' },
  { title: 'Должности', value: 'positions', icon: 'ri-nurse-line' },
]
